import PropTypes from 'prop-types';
import Tooltip from '$src/components/Tooltip';
import { AlertsIcon } from '@ring-icons';
import GuardMonitoringCell from './GuardMonitoringCell';

import './GuardMonitoring.less';

function GuardMonitoring({enabled}) {
  return (
    <div className="guard-monitoring">
      {!enabled && (
        <div className="guard-monitoring--disabled">
          <Tooltip title="Guard Monitoring" description="Guard monitoring will resume when you opt in or when your billing cycle renews.">
            <div className="guard-monitoring--disabled-tooltip"></div>
          </Tooltip>
        </div>
      )}
      <div className="guard-monitoring__section--title">
        <p>Monitoring</p>
        <Tooltip
          title="Guard Monitoring"
          description="When this is enabled, guards will monitor motion events on your enrolled cameras when your system is in Home or Away Mode. When the service is turned off, monitoring will pause and guards will not receive motion events from your enrolled cameras when you arm your system to Home or Away."
        >
          <AlertsIcon width="22px" />
        </Tooltip>
      </div>
      <GuardMonitoringCell />
    </div>
  );
}

GuardMonitoring.propTypes = {
  enabled: PropTypes.bool,
};

GuardMonitoring.defaultProps = {
  enabled: true
};


export default GuardMonitoring;
